import { getStore as getRootStore } from 'stores/common/selectors';
import { modalInitialState, ModalStore } from './store';

function getStore(state: any): ModalStore {
  const rootStore = getRootStore(state);
  return rootStore?.installations?.modals ?? modalInitialState;
}

export const selectors = {
  getStore,
};
